export default __webpack_public_path__ + "static/media/1003.445f288a.svg";